import ApiResourceManager from '../ApiResourceManager';

export default class FeatureFlagsManager extends ApiResourceManager {
  // Lists every known flag with its resolved state for the selected company
  // (the company is carried by the x-on-behalf-of-company header).
  get = () =>
    this.request({
      method: 'GET',
      url: '/feature-flags',
    });

  update = (flag, enabled) =>
    this.request({
      method: 'PUT',
      url: `/feature-flags/${flag}`,
      data: { enabled },
    });
}
